import RestProvider from "providers/RestProvider";
import { cruds, resetPassword } from "./RestaurarContrasenaData";
import { useHistory } from "react-router-dom";
import { useState } from "react";
import CryptoJS from "crypto-js";

const useFunctions = () => {
  const { crudOperation, crudOperationsType } = RestProvider();
  const history = useHistory();
  const [message, setMessage] = useState({ msg: "", severity: "" });
  let _ID = 0;
  const addAlert = (msg) => setAlerts([...alerts, { id: _ID++, msg }]);
  const [alerts, setAlerts] = useState([]);
  const handleSetMessage = (msg, severity) => {
    setMessage({ msg, severity });
    addAlert(message);
  };
  const [isLoading, setIsLoading] = useState(false);
  const [mostrarConfirmacion, setMostrarConfirmacion] = useState(false);
  const irAccesoConContrasena = () => { history.push("/AccesoConContrasena") }
  
  const [resetToken, setResetToken] = useState('');

  /**
   * @function handleOnSubmit Función que se ejecutará cuando se produzca en el formulario el evento onSubmit
   */
  const handleOnSubmit = async (data) => {
    setIsLoading(true);

    resetPassword.tokenReset = resetToken
    resetPassword.newPassword = hashPassword(data.data.containerContrasena.contrasena)
    
    
    await crudOperation(crudOperationsType.CUSTOM, cruds.loginRequest.resource, {
      url: cruds.loginRequest.url,
      method: "post",
      data: resetPassword,
    })
    .then(() => {
      setIsLoading(false)
      setMostrarConfirmacion(true)
    })
    .catch(function  (error) {
      setIsLoading(false)
      handleSetMessage("Error al cambiar la contraseña", "error")
    })
  };

  /**
   * @function handleCustomEvents Función que captura los eventos de los botones customizados
   * @param {*} customEvent
   */
  const handleCustomEvents = (customEvent) => {
    // Captura cuando se hace click sobre el botón Atrás
    if (customEvent.type === "btnAtras") {
      history.push('/AccesoConContrasena');
    }
  };

  /**
   * @function hashPassword Función que obtiene el hash256 de la contraseña suministrada por el usuario
   * @param {*} password
   * @returns
   */
  const hashPassword = (password) => {
    const hash = CryptoJS.SHA256(password);
    const hexHash = hash.toString(CryptoJS.enc.Hex);
    return hexHash;
  };

  return {
    handleOnSubmit,
    handleCustomEvents,
    isLoading,
    alerts,
    message,
    setMessage,
    irAccesoConContrasena,
    mostrarConfirmacion,
    setResetToken
  };
};

export default useFunctions;
